var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.isCDNEnabled)?_c('cache-viewer',{attrs:{"visible":_vm.showCacheViewer},on:{"update:visible":function($event){_vm.showCacheViewer=$event}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }